




















































import {Component} from 'vue-property-decorator';
import Report from '@/pdf/Report';
import Frontpage from '@/pdf/pages/Frontpage.vue';
import ReportBackground from '@/pdf/components/ReportBackground.vue';
import SummaryOverview from '@/pdf/components/SummaryOverview.vue';
import PageFooter from '@/pdf/components/PageFooter.vue';
import CompanyOverview from '@/pdf/pages/CompanyOverview.vue';
import CompanyProfitLoss from '@/pdf/pages/CompanyProfitLoss.vue';
import CompanyBalance from '@/pdf/pages/CompanyBalance.vue';
import AppendixCompass from '@/pdf/pages/AppendixCompass.vue';
import Liability from '@/pdf/pages/Liability.vue';

@Component({
  components: {
    Frontpage,
    ReportBackground,
    SummaryOverview,
    PageFooter,
    CompanyOverview,
    CompanyProfitLoss,
    CompanyBalance,
    AppendixCompass,
    Liability},
})
export default class Company extends Report {
  async mounted() {
    await this.loadDocument();
  }
}
